var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindowsEnhancementsImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99.488,
    height: 99.171,
    viewBox: "0 0 99.488 99.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#e7e6e6;}.c{fill:#8c94c9;}.d{fill:#97d3f1;}.e{opacity:0.995;}.f{fill:#007da0;stroke:#347c9d;}.g{fill:#0fb4d1;}.h{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 99.488,
    height: 99.171,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "matrix(1, 0, 0, 1, -9, -6)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 40.744,
    cy: 40.586,
    rx: 40.744,
    ry: 40.586,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.373 1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33 -21)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(56.15 88.221)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(47.443 36.88)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(42.611 64.432)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22 -14)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(81.357 79.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(89.932 47.762)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(62.533 16.227)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(-123.807 83.324)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-42.057 -561.658)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M491.2,531.967q0,6.009,0,12.019a2.867,2.867,0,0,1-2.949,2.863q-12.437,0-24.875,0a2.909,2.909,0,0,1-2.888-1.9,3.03,3.03,0,0,1-.158-.993q-.014-9.8-.007-19.6c0-1.469,0-2.938,0-4.407a2.86,2.86,0,0,1,2.98-2.862c8.281,0,16.561.015,24.842-.014a3.014,3.014,0,0,1,3.067,2.966C491.177,524.018,491.205,527.992,491.2,531.967Zm-29.471-8.113c-.007.113-.017.2-.017.279q0,9.975,0,19.95c0,.955.488,1.426,1.476,1.427q12.555,0,25.11,0c1.041,0,1.511-.453,1.511-1.455q0-9.928,0-19.855c0-.112-.012-.223-.019-.346Zm-.017-1.358h28.062a.676.676,0,0,0,.033-.138c0-.909,0-1.818-.007-2.727a1.105,1.105,0,0,0-.053-.311,1.279,1.279,0,0,0-1.417-.89q-3.044,0-6.087,0H463.262c-1.076,0-1.543.453-1.546,1.489,0,.613,0,1.226,0,1.839C461.717,522,461.717,522.237,461.717,522.5Z",
    transform: "translate(-268.27 -14.126)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M589.47,562.017a.984.984,0,0,1-.989-1,1,1,0,1,1,2,.022A.981.981,0,0,1,589.47,562.017Z",
    transform: "translate(-385.409 -55.093)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M546.9,562a.971.971,0,0,1-1.009-.978,1,1,0,0,1,.978-1.022,1.031,1.031,0,0,1,1.022.991A1,1,0,0,1,546.9,562Z",
    transform: "translate(-346.477 -55.083)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M505.05,561.009a.973.973,0,0,1-.995.993,1,1,0,0,1-1.005-.994A1.033,1.033,0,0,1,504.058,560,1,1,0,0,1,505.05,561.009Z",
    transform: "translate(-307.253 -55.082)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M79,134.093l-.207-.1v-.012h-1.33a6.328,6.328,0,0,0-.671-1.623l.915-.915.024-.024-.012-.012.085-.22a.562.562,0,0,0-.134-.622l-1.294-1.294a.585.585,0,0,0-.622-.134l-.22.085-.012-.012-.024.024-.915.915a6.327,6.327,0,0,0-1.623-.671v-1.33h-.012l-.1-.207a.593.593,0,0,0-.537-.342H70.518a.593.593,0,0,0-.537.342l-.1.207h-.012v1.33a6.328,6.328,0,0,0-1.623.671l-.915-.915-.024-.024-.012.012-.22-.085a.563.563,0,0,0-.622.134l-1.282,1.306a.584.584,0,0,0-.134.622l.085.22-.012.012.024.024.915.915a6.327,6.327,0,0,0-.671,1.623h-1.33v.012l-.207.1a.593.593,0,0,0-.342.537v1.818a.593.593,0,0,0,.342.537l.207.1v.012h1.343a6.327,6.327,0,0,0,.671,1.623l-.915.915-.024.024.012.012-.085.22a.562.562,0,0,0,.134.622l1.294,1.294a.585.585,0,0,0,.622.134l.22-.085.012.012.024-.024.915-.915a6.326,6.326,0,0,0,1.623.671v1.33h.012l.1.207a.593.593,0,0,0,.537.342h1.819a.593.593,0,0,0,.537-.342l.1-.207h.012v-1.33a6.327,6.327,0,0,0,1.623-.671l.915.915.024.024.012-.012.22.085a.562.562,0,0,0,.622-.134l1.294-1.294a.584.584,0,0,0,.134-.622l-.085-.22.012-.012-.024-.024-.915-.915a6.327,6.327,0,0,0,.671-1.623h1.33v-.012l.207-.1a.593.593,0,0,0,.342-.537v-1.818A.673.673,0,0,0,79,134.093Zm-7.579,4.137a2.7,2.7,0,1,1,2.7-2.7A2.7,2.7,0,0,1,71.421,138.23Z",
    transform: "translate(135.912 385.122)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsEnhancementsImage);
export default __webpack_public_path__ + "static/media/windowsEnhancementsImage.343330f60923ca7ff653e14d72137fd2.svg";
export { ForwardRef as ReactComponent };